import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ApplicationLoginLog } from './application-login-log';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { NgbNav, NgbModal, NgbModalOptions, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { RestAPIService } from '../shared/shared-service/restAPI.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { SharedDataService } from '../shared/shared-data/shared-data.service';
import { CustomTableComponent, TableColumnSettings } from '../shared/custom-table/custom-table.component';
import { createAnchorLink, DEFAULT_DT_OPTION_FAILED, DEFAULT_DT_OPTION_SUCCESS, TABLE_COLUMN_LIST, TABLE_COLUMN_LIST_FAILED } from './constant';

@Component({
  selector: 'app-application-login-log',
  templateUrl: './application-login-log.component.html',
  styleUrls: ['./application-login-log.component.scss']
})
export class ApplicationLoginLogComponent implements OnInit {
  @BlockUI() blockUI: NgBlockUI;
  closeResult: string;
  applicationName: string;
  loginLog: ApplicationLoginLog;
  applicationLoginLogs: ApplicationLoginLog[];
  dropdownList = [];
  dropdownSettings = {};
  selectedApplication: string;
  failureReasons: string[];
  dtOptions: DataTables.Settings = {};
  activeTab="successful";
  @ViewChild('tabs',{static:false})
  private tabSet: NgbNav;
  @ViewChild('content')
  reasonsModal: TemplateRef<any>;

  /**Pagination**/
  rowSizeSuccess = 10;
  currentPageSuccess = 0;
  totalRecordsSuccess = 0;
  sortBySuccess = "time";
  sortOrderSuccess = false;

  rowSizeFailure = 10;
  currentPageFailure = 0;
  totalRecordsFailure = 0;
  sortByFailure = "time";
  sortReverseFailure = false;

  /**Pagination till here**/
  @ViewChild('successLoginLogs')
  successLoginLogsTable: CustomTableComponent;
  dtOptionsSuccess: DataTables.Settings = DEFAULT_DT_OPTION_SUCCESS;
  columnListSuccess: TableColumnSettings[] = [];

  dtOptionsFailed: DataTables.Settings = DEFAULT_DT_OPTION_FAILED;
  @ViewChild('failedLoginLogs')
  failedLoginLogsTable: CustomTableComponent;
  columnListFailed: TableColumnSettings[] = [];
  modalTitle: string = '';

  constructor(private router: Router, private sharedDataService: SharedDataService, private route: ActivatedRoute, private modalService: NgbModal, private restAPIService: RestAPIService, private datePipe: DatePipe) {

    this.columnListSuccess = TABLE_COLUMN_LIST;
    this.columnListFailed = TABLE_COLUMN_LIST_FAILED;
    this.updateUsersColumns();
    this.loginLog = new ApplicationLoginLog();
    this.selectedApplication = null;
  }

  ngOnInit(): void {
    this.activeTab = this.route.snapshot.params.activeTab;
  }


  /**
   * Event call backs
   */
   dtAjaxCallSuccess({ dataTablesParameters, callback }) {
    const sortOrder = dataTablesParameters.order[0].dir;
    if (sortOrder === 'asc') {
      this.sortOrderSuccess = true;
    } else {
      this.sortOrderSuccess = false;
    }


    this.blockUI.start("Loading..Please wait..")
    this.loginLog.applicationName = this.selectedApplication;
    this.restAPIService.getSuccessfulApplicationLogs(this.loginLog, dataTablesParameters.length, dataTablesParameters.start / dataTablesParameters.length, dataTablesParameters.search.value, this.columnListSuccess[dataTablesParameters.order[0].column].data, this.sortOrderSuccess).
      then(applicationLoginLogResponse => {
        const applicationLoginLog = applicationLoginLogResponse.loginLogs;
        if (applicationLoginLog) {
          for (let i = 0; i < applicationLoginLog.length; i++) {
            applicationLoginLog[i].time = this.datePipe.transform(applicationLoginLog[i].time, 'MM/dd/yyyy HH:mm:ss');
          }
          this.applicationLoginLogs = applicationLoginLog;

          // if (this.applicationLoginLogs.length > 0) {
          callback({
            recordsTotal: applicationLoginLogResponse.count,
            recordsFiltered: applicationLoginLogResponse.filteredCount,
            data: this.applicationLoginLogs
          });
        } else {
          this.showEmptyTable(callback);
        }
        this.blockUI.stop();
      })
      .catch(error => {
        this.sharedDataService.showError(error.message);
        this.showEmptyTable(callback);
        this.blockUI.stop();
      });

  }

  dtAjaxCallFailed({ dataTablesParameters, callback }) {
    const sortOrder = dataTablesParameters.order[0].dir;
    if (sortOrder === 'asc') {
      this.sortReverseFailure = true;
    } else {
      this.sortReverseFailure = false;
    }
    this.blockUI.start("Loading..Please wait..")
    this.loginLog.applicationName = this.selectedApplication;

    this.restAPIService.getFailedApplicationLogs(this.loginLog, dataTablesParameters.length, dataTablesParameters.start / dataTablesParameters.length, dataTablesParameters.search.value, this.columnListFailed[dataTablesParameters.order[0].column].data, this.sortReverseFailure).
      then(applicationLoginLogResponse => {
        const applicationLoginLog = applicationLoginLogResponse.loginLogs;
        if (applicationLoginLog) {
          this.applicationLoginLogs = applicationLoginLog;
          // if ( this.applicationLoginLogs.length > 0) {
          callback({
            recordsTotal: applicationLoginLogResponse.count,
            recordsFiltered: applicationLoginLogResponse.filteredCount,
            data: this.applicationLoginLogs
          });
        } else {
          this.showEmptyTable(callback);
        }
        this.blockUI.stop();
      })
      .catch(error => {
        this.sharedDataService.showError(error.message);
        this.showEmptyTable(callback);
        this.blockUI.stop();
      });

  }


  onTabchange(data: any) {
    if (data === 'successful') {
      this.router.navigate(['/layout/loginlog/successful']);
    }
    if (data === 'failed') {
      this.router.navigate(['/layout/loginlog/failed']);
    }
  }


  /**
   * Event call backs
   */

  onRowInit(event: any) {
    const that = this;
    let element;
    if(this.activeTab === 'successful')
    {
      element = this.successLoginLogsTable.getTableBody();
    } else{
      element = this.failedLoginLogsTable.getTableBody();
    }
    if (element !== undefined || element !== null) {
      const element1 = element.item(event.index());

      if (element1 !== undefined && element1 !== null) {
        let viewLink;
        if(this.activeTab === 'successful')
        {
          viewLink = element1.children.item(6);
          this.modalTitle = 'Success ';
        } else{
          viewLink = element1.children.item(5);
          this.modalTitle = 'Failure ';
        }
        $('a', viewLink)
          .unbind('click')
          .on('click', function () {
            const viewButton: any = this;
            const id = viewButton.id;
            that.getFailureReasons(id)
          });
      }
    }
  }

  public getFailureReasons(id: any) {
    const log = this.applicationLoginLogs.find(data => data.id == id)
    this.open(log);
  }

  open(log: ApplicationLoginLog) {
    this.applicationName = log.applicationName;
    // this.failureReasons = log.failureReasonList;
    this.failureReasons = log.reasonsList;
    const options: NgbModalOptions = {
      size: 'lg',
      backdrop: 'static',
      keyboard: false
    };
    this.modalService.open(this.reasonsModal, options).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;

    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }


  private updateUsersColumns() {
    const actionItem = function () {
      return {
        title: 'Reasons',
        data: 'view',
        className: 'text-center',
        render(_data: any, _type: any, _full: any) {
          // return createButtonElement(_full.id, 'view');
          return createAnchorLink(_full.id, 'view');
        }
      };
    }.call(this);
    // Object and array combined as per es5
    this.columnListFailed = this.columnListFailed.concat([actionItem]);
    this.columnListSuccess = this.columnListSuccess.concat([actionItem]);
  }

  showEmptyTable(callback: any) {
    callback({
      recordsTotal: 0,
      recordsFiltered: 0,
      data: []
    });
  }


}
